import moment from 'moment';

import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';

import { getLessonDetails } from '../../../../../services/apiService';
import { toast } from 'react-toastify';
import './index.css';

const columnDefs = [
  { field: 'id', hide: true },
  { field: 'name', headerName: 'Name', cellRenderer: 'agGroupCellRenderer' },
  { field: 'moduleName' },
  { field: 'status' },
  {
    field: 'completedAt',
    headerName: 'Completed On',
    valueFormatter: (params) => {
      return params?.value ? moment(params?.value).format('DD MMM YYYY') : '-';
    },
  },
];

const defaultColDef = {
  filter: true,
  sortable: true,
  resizable: true,
  menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
  headerComponentParams: {
    menuIcon: 'fa-bars',
    template: `<div class="ag-cell-label-container" role="presentation">  
                            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>  
                            <div ref="eLabel" class="ag-header-cell-label" role="presentation">    
                                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>    
                                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>    
                                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>    
                                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>    
                                <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>    
                                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>  
                            </div>
                        </div>`,
  },
};

const pageSize = 10;

const gridOptions = {
  columnDefs: columnDefs,
  masterDetail: true,
  detailCellRendererParams: {
    detailGridOptions: {
      columnDefs: [
        { field: 'moduleId', hide: true },
        { field: 'activityId', hide: true },
        { field: 'activityType' },
        { field: 'activityStatus' },
        {
          field: 'createdAt',
          cellRenderer: (params) => {
            return (
              <div className='flex items-center h-full'>
                {moment(params?.data?.createdAt).format('DD MMM YYYY, h:mm a')}
              </div>
            );
          },
        },
        {
          field: 'updatedAt',
          cellRenderer: (params) => {
            return (
              <div className='flex items-center h-full'>
                {moment(params?.data?.updatedAt).format('DD MMM YYYY, h:mm a')}
              </div>
            );
          },
        },
      ],
    },
    getDetailRowData: (params) => {
      params.successCallback(params.data.lessonActivities);
    },
  },
};

function Lesson({ goalType, userId }) {
  const [rowData, setRowData] = useState(null);

  const fetchData = async () => {
    try {
      if (goalType && userId) {
        const response = await getLessonDetails(goalType, userId);
        setRowData(response);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch data');
    }
  };

  useEffect(() => {
    fetchData();
  }, [goalType, userId]);

  return (
    <div>
      <div
        className='ag-theme-alpine h-96  w-full'
        style={{ height: '490px' }}
      >
        <AgGridReact
          //   className='ag-theme-alpine'
          //   animateRows='true'
          // columnDefs={columnDefs}
          gridOptions={gridOptions}
          defaultColDef={defaultColDef}
          //   enableRangeSelection='true'
          rowData={rowData}
          rowSelection='multiple'
          suppressRowClickSelection='true'
          tooltipShowDelay={0}
          tooltipHideDelay={2000}
          pagination={true}
          paginationPageSize={pageSize}
          rowHeight={50}
        />
      </div>
    </div>
  );
}

export default Lesson;
